﻿$.fn.dxCtrlPageSaisieCbSumUp = function custom_dxCtrlPageSaisieCbSumUp(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpagesaisiecbsumup");
        this.instance = new cdxCtrlPageSaisieCbSumUp(this, option);
    }
    return this;
}

window.cdxCtrlPageSaisieCbSumUp = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.isPreview == 'undefined') option.isPreview = false

    var popupFullScreen = null
    function mConstruit() {
        container.empty()
        popupFullScreen = $("<div/>").appendTo("body").dxCtrlPopupBase({
            fullScreen: true,
            showTitle: false,
            contentTemplate: function (contentElement) {
                var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                jauge.mShow()
                contentElement.css("padding", "0px")
                contentElement.css("position", "relative")

                var $DivImageFond = $("<div style='width:100%;height:100%;position:absolute;z-index:1;'/>").appendTo(contentElement)

                //var urlFond = ((option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").length == 0) ? "" : option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").split("|")[1])
                //var opacity = ((option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").length == 0) ? 1 : option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").split("|")[0] / 100)
                var urlFond = ""
                var opacity = 0
                var idxImage = Math.floor(Math.random() * 20) + 1;
                urlFond = parametre.urldispatch + "/img/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + idxImage + ".jpg"
                opacity = 0.3

                $DivImageFond.css({
                    "background-attachment": "fixed",
                    "background-size": "cover",
                    "background-repeat": "no-repeat",
                    "background-position": "center",
                    "background-image": "url(" + urlFond + ")",
                    "opacity": opacity
                })

                if (typeof option.showClose == 'undefined' || option.showClose) {
                    dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(contentElement).dxCtrlButton({
                        icon: 'fas fa-times',
                        width: HeightButton,
                        height: HeightButton,
                        onClick: function (e) {
                            popupFullScreen.hide()
                            if (typeof option.onCancel != 'undefined') option.onCancel()
                        }
                    }).dxCtrlButton("instance");
                }

                if (option.isPreview) {
                    //on est dans une prévisualisation
                    //on rajoute une div bloquante
                    //on rajoute les boutons pour charger l'image de fond
                    $("<div style='width:100%;height:100%;position:absolute;z-index:50;'/>").appendTo(contentElement)
                    var $Table = $("<table style='position:absolute;top:10px;left:10px;z-index:51;'/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Charger une image de fond",
                        onClick: function (e) {
                            $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                                bddCtrl: option.bddCtrl,
                                multiple: false,
                                accept: ".png,.jpg,.jpeg,.gif,.bmp",
                                onValide: function (lstUrlFile) {
                                    var url = lstUrlFile[0];
                                    if (typeof url != 'undefined') {
                                        (new cImage(option.bddCtrl)).mImgUrltoData64(url, function (data64) {
                                            option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb", "100|" + data64)
                                            $DivImageFond.css({
                                                "background-attachment": "fixed",
                                                "background-size": "cover",
                                                "background-repeat": "no-repeat",
                                                "background-position": "center",
                                                "background-image": "url(" + data64 + ")",
                                                "opacity": dxOpacity.option("value") / 10
                                            })
                                            dxBtSupImgFond.option("visible", true)
                                            dxOpacity.option("visible", true)
                                            dxOpacity.option("value", 10)
                                            option.onChangeImageFond()
                                        }, function () {
                                            jauge.mHide()
                                            mNotify("Impossible d'utiliser cette image", "error", 6000)
                                        })
                                    }
                                },
                                optionFileUploader: {
                                    bddCtrl: option.bddCtrl,
                                    maxFileSizeOctetImage: 20971520 //10 Mo
                                }
                            }).dxCtrlFileUploaderPopup("instance")
                        }
                    })
                    var $Td = $("<td/>").appendTo($Tr)
                    var dxOpacity = $("<div class='barlow center dx-theme-material-typography'/>").appendTo($Td).dxCtrlNumberBox({
                        label: "Opacité",
                        labelMode: 'floating',
                        visible: (option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").length > 0),
                        width: 130,
                        isFloat: false,
                        format: "#0'%'",
                        min: 0,
                        max: 100,
                        desactiveTimeout: true,
                        value: ((option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").length == 0) ? 100 : option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").split("|")[0]),
                        onValueChanged: function (e) {
                            option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb", e.value + "|" + option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").split("|")[1])
                            $DivImageFond.css({
                                "background-attachment": "fixed",
                                "background-size": "cover",
                                "background-repeat": "no-repeat",
                                "background-position": "center",
                                "background-image": "url(" + option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").split("|")[1] + ")",
                                "opacity": dxOpacity.option("value") / 100
                            })
                            e.component.element().find("input").css({
                                "text-align": "center",
                                "padding-left": "0px",
                                "padding-right": "0px"
                            })
                            option.onChangeImageFond()
                        },
                        buttonLeftRight: true,
                        //buttons: [{
                        //    focusStateEnabled: false,
                        //    name: 'pre',
                        //    location: 'before',
                        //    options: {
                        //        icon: 'spinprev',
                        //        stylingMode: 'text',
                        //        onClick() {
                        //            if (dxOpacity.option("value") == null) { dxOpacity.option("value", 1) }
                        //            else {
                        //                if (dxOpacity.option("value") - 1 > 0) dxOpacity.option("value", dxOpacity.option("value") - 1)
                        //            }
                        //        },
                        //    },
                        //}, {
                        //    focusStateEnabled: false,
                        //    name: 'next',
                        //    location: 'after',
                        //    options: {
                        //        icon: 'spinnext',
                        //        stylingMode: 'text',
                        //        onClick() {
                        //            if (dxOpacity.option("value") == null) { dxOpacity.option("value", 1) }
                        //            else {
                        //                if (dxOpacity.option("value") + 1 < 10) dxOpacity.option("value", dxOpacity.option("value") + 1)
                        //            }
                        //        },
                        //    },
                        //}],
                        onContentReady: function (e) {
                            e.component.element().find("input").css({
                                "text-align": "center",
                                "padding-left": "0px",
                                "padding-right": "0px"
                            })
                        }
                    }).dxCtrlNumberBox("instance")
                    var $Td = $("<td/>").appendTo($Tr)
                    var dxBtSupImgFond = $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Supprimer l'image de fond",
                        visible: (option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb").length > 0),
                        onClick: function (e) {
                            option.bddCtrl.paraAppli.mGetPara("doccpt_general_data_url_base64_image_fond_cb", "")
                            $DivImageFond.css({
                                "background-attachment": "fixed",
                                "background-size": "cover",
                                "background-repeat": "no-repeat",
                                "background-position": "center",
                                "background-image": "url()",
                                "opacity": "1"
                            })
                            dxBtSupImgFond.option("visible", false)
                            dxOpacity.option("visible", false)
                            option.onChangeImageFond()
                        }
                    }).dxCtrlButton("instance")
                }

                $Div = $("<div style='height:100%;width:100%;padding-top:10px;display:flex;align-items:flex-start;justify-content:center;position:absolute;z-index:49;'/>").appendTo(contentElement)
                var $DivContainer = $("<div style='max-width:350px;'/>").appendTo($Div)
                dxPageEnteteCb = $("<div style='padding-bottom:10px;'/>").appendTo($DivContainer).dxCtrlEnteteSaisieCb(option).dxCtrlEnteteSaisieCb("instance")
                var dxSaisieCb = $("<div/>").appendTo($DivContainer).dxCtrlSaisieCbSumUp({
                    bddCtrl: option.bddCtrl,
                    id_table: option.id_table,
                    id: option.id,
                    amount100: option.amount100,
                    id_societe: option.id_societe,
                    title: option.title,
                    isPreview: option.isPreview,
                    onValidePaiement: function (amount100, paiementIntent) {
                        popupFullScreen.hide()
                        option.onValidePaiement(amount100, paiementIntent)
                    },
                    onErrorPaiement: function (message) {
                        if (typeof option.onErrorPaiement != 'undefined') { option.onErrorPaiement(message) }
                        else { mNotify("Erreur durant le règlement CB.<br/>" + message, "error", 6000) }
                        popupFullScreen.hide()
                    },
                    onContentReady: function () {
                        jauge.mHide()
                    }
                }).dxCtrlSaisieCbSumUp("instance")

            }
        }).dxCtrlPopupBase("instance")
        popupFullScreen.show()
    }

    this.mClose = function () { popupFullScreen.hide(); }

    this.element = function () { return container }

    mConstruit();
}